<ng-container *ngIf="dialogue?.dialogueBlock?.information">
  <div
    class="constellation-logo"
    [ngClass]="{ 'header-transition': !isEmbedded }"
    *ngIf="!dialogue.dialogueBlock.information.headerMedia?.url && !dialogue.dialogueBlock.information.media?.url">
    <kp-reflect-animation [skipIntro]="true"></kp-reflect-animation>
  </div>
  <div class="header-image-wrap">
    <img
      class="header-image"
      [ngClass]="{ 'header-transition': !isEmbedded }"
      *ngIf="dialogue.dialogueBlock.information.headerMedia?.url !== null"
      [src]="dialogue.dialogueBlock.information.headerMedia?.url + '?w=768'"
      [alt]="dialogue.dialogueBlock.information.headerMedia?.description" />
  </div>
  <h3 class="header" [ngClass]="{ 'header-transition': !isEmbedded }" *ngIf="dialogue.dialogueBlock.information.header">
    {{ dialogue.dialogueBlock.information.header }}
  </h3>
  <kui-rich-text
    class="rich-text"
    [ngClass]="{ 'rich-text-transition': !isEmbedded }"
    [richText]="dialogue.dialogueBlock.information.body"
    [targetExternalLinks]="true"
    [onBackground]="true"></kui-rich-text>
  <kp-audio-player
    class="media-container hidden-print"
    [ngClass]="{ 'primary-media-transition': !isEmbedded }"
    [url]="dialogue.dialogueBlock.information.media?.url"
    [title]="dialogue.dialogueBlock.information.media?.title"
    *ngIf="dialogue.dialogueBlock.information.media?.isAudio"></kp-audio-player>
  <kp-video-player
    class="media-container hidden-print"
    [ngClass]="{ 'primary-media-transition': !isEmbedded }"
    [altText]="dialogue.dialogueBlock.information.media?.placeholderImage?.description"
    [url]="dialogue.dialogueBlock.information.media?.url"
    [title]="dialogue.dialogueBlock.information.media?.title"
    [image]="dialogue.dialogueBlock.information.media?.placeholderImage?.url"
    *ngIf="dialogue.dialogueBlock.information.media?.isVideo"
    [primary]="dialogue.logicKey !== DialogueLogicKey.dialogue_purposeful_onboarding_v1"></kp-video-player>
</ng-container>
